import React, { useState } from "react";
import { connect } from "react-redux";
import UserRoleList from "./UserRoleList";
import CreateNewUserRole from "./CreateNewUserRole";

const Maincontent = () => {
  const [updatelist, setUpdatelist] = useState(true);

  return (
    <>
      <div className="site-layout-background main-frame">
        <CreateNewUserRole
          setUpdatelist={setUpdatelist}
          updatelist={updatelist}
        />
        <UserRoleList updatelist={updatelist} setUpdatelist={setUpdatelist} />
      </div>
    </>
  );
};

export default connect()(Maincontent);
